// extracted by mini-css-extract-plugin
export default {"icon":"DescriptionDisplay_icon__-9ESN","specsTitleContainer":"DescriptionDisplay_specsTitleContainer__AYvEa","specsTitleText":"DescriptionDisplay_specsTitleText__c6PdD"};